import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header-modify-button__menu__wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { computed, ref, StyleValue, watch, onMounted, onUnmounted, nextTick } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { HeaderList } from '@/coreDomainsModule/table';

const MENU_WIDTH = 200;
const MENU_OFFSET_Y = 6;
const MENU_MIN_HEIGHT = 300;


export default /*@__PURE__*/_defineComponent({
  __name: 'TableHeaderModifyButton',
  props: {
    modifiableHeaderList: {},
    isOpen: { type: Boolean, default: undefined },
    disabled: { type: Boolean },
    toolTipMessage: { default: undefined }
  },
  emits: ["toggle", "toggleMenu"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "441dc133": (`${MENU_WIDTH}px`),
  "80d8ec12": (`${tableHeaderModifyButtonHeight.value}px`)
}))

const props = __props;

onMounted(() => {
  if (props.isOpen) {
    onClickButton();
  }
});

const emits = __emit;

const tableHeaderModifyMenuStyle = computed((): StyleValue => {
  return {
    top: `${tableHeaderModifyButtonPosition.value.y}px`,
    left: `${tableHeaderModifyButtonPosition.value.x}px`,
  };
});

const isMenuOpenedState = ref(false);
const buttonRef = ref<HTMLElement | null>(null);
const tableHeaderModifyButtonPosition = ref({
  x: 0,
  y: 0,
});
const tableHeaderModifyButtonHeight = ref(0);

watch(
  () => props.isOpen,
  (newValue) => {
    if (newValue === isMenuOpenedState.value) return;
    onClickButton();
    return;
  }
);

/**
 * メニュー位置を、押されたボタン自身を基準に更新する
 */
const updateMenuPosition = () => {
  const buttonContent = buttonRef.value;
  if (!buttonContent) return;

  const buttonRect = buttonContent.getBoundingClientRect();
  const menuTop = buttonRect.bottom + MENU_OFFSET_Y;
  tableHeaderModifyButtonPosition.value = {
    x: buttonRect.right - MENU_WIDTH,
    y: menuTop,
  };

  const tableContent = buttonContent.closest('.base-table-wrapper');
  if (tableContent instanceof HTMLElement) {
    const tableRect = tableContent.getBoundingClientRect();
    tableHeaderModifyButtonHeight.value = Math.max(MENU_MIN_HEIGHT, tableRect.bottom - menuTop);
    return;
  }

  tableHeaderModifyButtonHeight.value = Math.max(MENU_MIN_HEIGHT, window.innerHeight - menuTop);
};

/**
 * メニュー表示中のスクロール・リサイズに追従する
 */
const addPositionListeners = () => {
  window.addEventListener('scroll', updateMenuPosition, true);
  window.addEventListener('resize', updateMenuPosition);
};

/**
 * メニュー位置更新用のイベントリスナーを解除する
 */
const removePositionListeners = () => {
  window.removeEventListener('scroll', updateMenuPosition, true);
  window.removeEventListener('resize', updateMenuPosition);
};

/**
 * ボタンクリック時orモーダル外をクリックした際の処理
 */
const onClickButton = async () => {
  if (!isMenuOpenedState.value) {
    updateMenuPosition();
    addPositionListeners();
  } else {
    removePositionListeners();
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
  if (isMenuOpenedState.value) {
    await nextTick();
    updateMenuPosition();
  }
  emits('toggleMenu', isMenuOpenedState.value);
};

onUnmounted(() => {
  removePositionListeners();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass({ 'table-header-modify-button__container--disabled': _ctx.disabled })
    }, [
      _createElementVNode("button", {
        ref_key: "buttonRef",
        ref: buttonRef,
        class: _normalizeClass(["table-header-modify-button__button", { 'table-header-modify-button__button--disabled': _ctx.disabled }]),
        onClick: onClickButton
      }, [
        _createVNode(SvgLoader, {
          class: "table-header-modify-button__button__icon",
          name: "plusIconForTableHeaderModify"
        })
      ], 2)
    ], 2)), [
      [
        _directive_tooltip,
        _ctx.toolTipMessage,
        void 0,
        { bottom: true }
      ]
    ]),
    (isMenuOpenedState.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "table-header-modify-button__bg",
            onClick: onClickButton
          }),
          _createElementVNode("div", {
            class: "table-header-modify-button__menu",
            style: _normalizeStyle(tableHeaderModifyMenuStyle.value)
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modifiableHeaderList, (header) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: header.key,
                  class: "table-header-modify-button__menu__button"
                }, [
                  (header.isShown)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (emits('toggle', header.key, true))
                      }, [
                        _createVNode(SvgLoader, {
                          class: "table-header-modify-button__menu__icon",
                          name: "iconEyeEnabledForTableHeaderModify"
                        })
                      ], 8, _hoisted_2))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (emits('toggle', header.key, false))
                      }, [
                        _createVNode(SvgLoader, {
                          class: "table-header-modify-button__menu__icon",
                          name: "iconEyeDisableForTableHeaderModify"
                        })
                      ], 8, _hoisted_3)),
                  _createTextVNode(" " + _toDisplayString(header.text), 1)
                ]))
              }), 128))
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})